import * as z from 'zod';
import { createSelectSchema } from 'drizzle-zod';
import { ACCOUNT_NAME_MAX_LENGTH, ACCOUNT_NUMBER_MAX_LENGTH, AccountType, BANK_CODE_MAX_LENGTH, BANK_NAME_MAX_LENGTH, BRANCH_CODE_MAX_LENGTH, BRANCH_NAME_MAX_LENGTH } from '@iichi/domain/bank-account';
import type { QueryResult } from '@iichi/schema-database/types/bank-account';
import * as schema from '@iichi/schema-database';

export const bankAccountSchema = createSelectSchema(schema.bankAccount)
  .pick({
    accountName: true,
    accountNumber: true,
    accountType: true,
    bankCode: true,
    bankName: true,
    branchCode: true,
    branchName: true,
  })
  .extend({
    accountName: z
      .string()
      .min(1)
      .max(ACCOUNT_NAME_MAX_LENGTH)
      // eslint-disable-next-line no-irregular-whitespace
      .regex(/^[\d A-Za-z―　「」ァ-ヶ・ー（），－．／０-９Ａ-Ｚａ-ｚ￥]+$/, '全角カナ・アルファベット・数字で入力して下さい'),
    accountNumber: z
      .string()
      .min(1)
      .max(ACCOUNT_NUMBER_MAX_LENGTH)
      .regex(/^\d{7}$/, '半角数字7桁で入力して下さい'),
    accountType: z.enum(AccountType),
    bankCode: z.string().min(1).max(BANK_CODE_MAX_LENGTH).regex(/^\d+$/),
    bankName: z.string().min(1).max(BANK_NAME_MAX_LENGTH),
    branchCode: z.string().min(1).max(BRANCH_CODE_MAX_LENGTH).regex(/^\d+$/),
    branchName: z.string().min(1).max(BRANCH_NAME_MAX_LENGTH),
  });
export type BankAccount = z.infer<typeof bankAccountSchema>;

export const serialize = (data: QueryResult): BankAccount => {
  return bankAccountSchema.parse(data);
};
